import React from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { H6, Label, P } from './text';
import { ISchild } from '../models/page';

export interface IHistoryStatsCardsProps {
	schilden: ISchild[] | ISchild;
	defaultOpen?: boolean;
}

export default function HistoryStatsCards({ schilden, defaultOpen = false }: IHistoryStatsCardsProps) {
	return (
		<div className="bg-white py-12 sm:py-16 mb-4">
			<div className="mx-auto max-w-7xl px-6 lg:px-8">
				{Array.isArray(schilden) &&
					schilden.map((schild, index) => (
						<div key={index} className="mb-12">
							<div className="mx-auto max-w-4xl lg:mx-0">
								<h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
									{schild.seizoensTitel}
								</h2>
							</div>
							{schild.seizoen?.map((seizoen, schildIndex) => (
								<Disclosure key={schildIndex} defaultOpen={defaultOpen}>
									{({ open }) => (
										<>
											<div className="relative mt-12 mb-8">
												<div
													className="absolute inset-0 left-[10%] flex items-center"
													aria-hidden="true"
												>
													<div className="w-full border-t border-gray-300" />
												</div>
												<Disclosure.Button className="relative flex justify-start bg-white pr-2">
													<Label className="bg-white pr-3">{seizoen.periodeTitel}</Label>
													<ChevronDownIcon
														className={`${
															open
																? 'rotate-180 transform transition-all'
																: ' transition-all'
														} h-6 w-6 text-black-500`}
													/>
												</Disclosure.Button>
											</div>
											<Disclosure.Panel>
												<ul
													key={index}
													role="list"
													className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
												>
													{seizoen.periode?.map((speler, spelerIndex) => (
														<li key={spelerIndex}>
															<img
																className="aspect-[1/1] w-full rounded-2xl object-cover"
																src={speler.img?.sourceUrl}
																alt={speler.img?.altText}
															/>
															<H6 className="mt-4">{speler.titel}</H6>
															<P>{speler.naam}</P>
															<P className="!text-black-200 !text-base">{speler.club}</P>
														</li>
													))}
												</ul>
											</Disclosure.Panel>
										</>
									)}
								</Disclosure>
							))}
						</div>
					))}
			</div>
		</div>
	);
}
